import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const stackRankState = (state: RootState) => state.stackRank;

export const getCustomMetrics = createSelector(
  stackRankState,
  ({ customMetrics }) => customMetrics
);

export const getCustomMetricsLoading = createSelector(stackRankState, ({ loading }) => loading);
export const getCustomMetricsUpdating = createSelector(stackRankState, ({ updating }) => updating);
export const getCustomMetricsDeleting = createSelector(stackRankState, ({ deleting }) => deleting);
